export const PROJECT_CONTENT = {
  project: 'Project',
  projects: 'Projects',
  projectName: 'Project name',
  projectMilestone: 'Project Milestone',
  projectMilestones: 'Project Milestones',
  projectActivity: 'Project Activity',
  projectImpacts: 'Project Impacts',
  projectImpact: 'Project Impact',
  projectScope: 'Project Scope',
  projectScopes: 'Project Scopes',
  projectStatus: 'Project Status',
  projectStatuses: 'Project Statuses',
  projectReports: 'Project Reports',

  // required
  requiredProjectStatus: 'Project status is required',

  archivedProjectMessage:
    'Archived project \n\nIt’s not allowed to take any action on archived projects. If you want to proceed, please unarchive the project first.',
  limitedNewProjectMessage:
    'You have reached the maximum number of projects allowed based on your ChangeSync Plan. To upgrade, please have your Administrator contact your ChangeSync account manager or email ',
  projectLabels: {
    title: 'Title of the project',
    owners: 'Project Owner(s)',
  },
  archivedProjectDescription:
    'Archiving a project will freeze all user additions, new activities, change impact creation, and stakeholder changes. The project is still available for reporting purposes and you can view and download all information and materials within the project.',
  projectMilestoneDescription:
    "Project Milestones can be change-specific or related to the overall project. Once saved, they will also appear on your project's timeline. You can can manage Milestones from here or the timeline.",
  projectMilestoneDescriptionForm:
    'When you create a Project Milestone, it will appear on the Change Strategy and in your Project Timeline. Milestones can be edited and deleted from the Change Strategy page or directly from the Project Timeline.',

  projectSponsors: 'Project Sponsor(s)',

  // reports
  projectDateRange: 'Project Date Range',

  customizeSettingChangeStrategyDescription:
    'Strategy Details are the critical characteristics of your change project that give others clear alignment and understanding of why the change is needed. You can rename, remove, and add fields to meet the unique needs of your project. Additionally, you can reorder the fields by clicking the arrow toggle.',

  noProjects: 'No Available Projects',
  projectStatusesLimitMess:
    'You’ve reached the limit for custom project statuses in account. You can optimize status list via renaming or deleting status(es).',
  changeImpactsLimitMess:
    "You can create up to 15 custom change impact types to accurately represent the various effects and outcomes of changes within your projects. These types are filterable and reportable. By utilizing these custom types, you can ensure that change impacts are assessed and communicated in a manner that aligns closely with your organization's priorities and challenges.",
  // tooltips
  projectStatusesTooltip:
    'You can create up to 10 custom project, portfolio and parent portfolio statuses to effectively communicate the current state and progress of projects in your portfolio to stakeholders. These statuses are filterable and reportable. They serve as concise indicators that convey important information about change efforts, milestones, risk, and other factors that are important to your organization.',
  surveyTemplateTooltip:
    'Create Survey and Assessment Templates that can be shared across all change projects and initiatives. Consistent standards and evaluation criteria will enhance your data quality, promote collaboration, and support continuous improvement of your change assessment tools over time.',
  permissionDenied:
    'It’s not allowed to take any action on archived projects. If you want to proceed, please unarchive the project first.',
  // delete
  deleteProjectStatus: 'Delete Project And Portfolio Status',
  deleteProjectStatusDescription:
    'Are you sure you want to delete this project and portfolio status? If it is used in projects or portfolios, it will remain available for the reporting purposes.',

  deleteChangeImpactType: 'Delete Change Impact Type',
  deleteChangeImpactTypeDescription:
    'Are you sure you want to delete this change impact type? If it is used in Projects, it will remain available for the reporting purposes.',

  deleteProject: 'Delete project',
  deleteProjectDescription: 'Are you sure you want to delete this project?',
  deleteProjectWithData:
    'The project has initiatives, change impacts, or change impact tasks that are currently being tracked by participants or task owners. If you confirm the action, all related data will be lost. If you don\'t want to lose data for reporting, change the project status to "Archived"',

  // project roles
  projectRoleSubtitle:
    'Associate a user with group and imply permissions for: initiatives, change impacts, feedback forms, employees.',
  projectRolesDescription1:
    'Can view all resources within project (except stakeholder analysis).',
  projectRolesDescription2:
    'Viewer permissions with additional ability to create, edit communication initiatives and linked files.',
  projectRolesDescription3:
    'Viewer permissions with additional ability to create, edit readiness initiatives and linked files.',
  projectRolesDescription4:
    'Viewer permissions with additional ability to create and edit training initiatives and linked files.',
  projectRolesDescription5:
    'Viewer permissions with additional ability to create and edit sustainment initiatives and linked files.',
  projectRolesDescription6:
    'Viewer permissions with additional ability to create and edit all resources within project.',
  projectRolesDescription7: 'Can manage users on the project.',
  projectRolesDescription8: 'Can invite other users to the project.',

  // group roles
  groupRolesDescription1:
    'Сan view initiatives, change impacts, feedback forms, employees that group has participated in.',
  groupRolesDescription2:
    'Leader permissions with additional ability to view files that have been allowed.',

  // empty states
  changeStrategyContentSubtitle:
    'The Change Strategy outlines important characteristics and gives others a high-level overview of the project and why the change is needed.',
  changeStrategyContentParagraphFirst:
    'Outlining the mission, vision, goals, risks, milestones, and governance structure of your change management project provides clarity, alignment, risk mitigation, accountability, clear direction, and focus by defining the desired outcomes of the change project.',
  changeStrategyContentParagraphThird:
    'Understanding characteristics of the change will help others partner with you as you build an approach, plans, and activities related to the change.',

  initiativeLinkedFilesParagraphSecond:
    "Simply copy the URL where you've stored your documents, handouts, images, or materials and link it to the projects or any initiative (change activity) you create in ChangeSync.",
  orgStakeholdersContentParagraphFirst:
    'In ChangeSync, the Organizational Stakeholders feature has powerful capabilities that simplify the process of creating, tracking, and analyzing stakeholders. The primary purpose of this structure is to facilitate seamless management of stakeholders on a global scale, spanning multiple projects, initiatives, change impacts, and workflows. Think of it as a centralized hub for managing stakeholders across your entire change portfolio.',

  // survey
  surveyDraftStatusDesc:
    'Feedback form is still being created and not available for selection across projects.',
  surveyCompleteStatusDesc:
    'Feedback form is built out, but has not yet been shared across projects.',
  surveyPublishedStatusDesc:
    'Feedback form is available for selection across all projects and ready to send.',
  noProjectsResult: 'Adjust your filters to query for more projects.',

  // project duplication
  duplicateProject: {
    title: 'Duplicate project',
    menuItem: 'Duplicate',
    source: 'Source:',
    archivedSourceNote: '(archived — the copy will be active)',
    namePrefix: 'Copy of',
    nameLabel: 'Project name',
    portfolioLabel: 'Portfolio',
    noPortfolio: 'No portfolio',
    whatToCopy: 'What to copy',
    selectAll: 'Select all',
    clearAll: 'Clear all',
    initiatives: 'Initiatives',
    submit: 'Duplicate',
    nameRequired: 'Enter a project name.',
    startDateRequired: 'Start Date is required',
    endDateRequired: 'End Date is required',
    endBeforeStart: 'End date must be after the start date.',
    duplicating: 'Duplicating…',
    warnings: {
      stakeholders:
        "Stakeholders aren't selected. Links to stakeholders in change impacts and initiatives won't be copied, and the copy will start with an empty stakeholder list.",
      teamAccess:
        "Team access isn't selected. Only project owners carry over; project and group roles won't be copied. Org admins and leaders keep their access.",
      someInitiatives:
        "{types} initiatives aren't selected. Initiatives of these types won't be copied, along with their participants, stakeholder links, linked files and surveys. Dashboards and reports in the copy will show no data for these types.",
      allInitiatives:
        "Initiatives aren't selected. No initiatives will be copied, along with their participants, stakeholder links, linked files and surveys. Dashboards and reports in the copy will show no data for initiatives.",
      nothingSelected:
        'Select at least one section, or the copy will only contain the project details and owners.',
    },
    tooltip: {
      alwaysCopiedTitle: 'Always copied',
      alwaysCopied:
        'Project details (scope, impact, status, matrix labels), owners and custom field setup.',
      withSectionTitle: 'Comes with each section',
      withSection:
        'Milestones and sponsors with the strategy, tasks with impacts, participants, files and survey setup with initiatives.',
      datesTitle: 'Dates',
      dates: 'Copied items get same dates.',
      neverCopiedTitle: 'Never copied',
      neverCopied:
        'Survey responses, completion progress, unsaved drafts and change history. Archived, deleted or inactive people, groups and stakeholders.',
      footer:
        "The source project is never changed. We'll notify you in the app and by email when the copy is ready.",
    },
    successTitle: 'Project duplicated',
    successBody: '"{name}" is ready in Active projects.',
    openProject: 'Open project',
  },

  // initiative duplication
  duplicateInitiative: {
    title: 'Duplicate initiative',
    menuItem: 'Duplicate',
    source: 'From:',
    titleSuffix: '(Copy)',
    titleLabel: 'Title',
    projectLabel: 'Project',
    projectPlaceholder: 'Select a project',
    whatToCopy: 'What to copy',
    whatGetsCopied: 'What gets copied?',
    selectAll: 'Select all',
    clearAll: 'Clear all',
    submit: 'Duplicate',
    duplicating: 'Duplicating…',
    titleRequired: 'Enter a title.',
    projectRequired: 'Select a project.',
    options: {
      participants: 'Participants',
      stakeholders: 'Stakeholders',
      feedbackForm: 'Feedback Form',
      linkedFiles: 'Linked Files',
    },
    warnings: {
      participantsTitle: "Participants aren't selected.",
      participants:
        'The copy will have no audience. Add groups or people before sending its feedback form.',
      stakeholdersTitle: "Stakeholders aren't selected.",
      stakeholders: "The copy won't be linked to any stakeholders.",
      feedbackFormTitle: 'Feedback form isn’t selected.',
      feedbackForm:
        'The copy will have no feedback form. You can create a new one after duplicating.',
      linkedFilesTitle: 'Linked files aren’t selected.',
      linkedFiles:
        'The copy will have no attached files. You can add them after duplicating.',
      nothingSelected:
        'Select at least one section, or the copy will only contain the initiative basic data.',
    },
    tooltip: {
      alwaysCopiedTitle: 'Always copied',
      alwaysCopied:
        'Title, lead, content, category, dates, impact, owner and the completion setting and mandatory settings. The copy keeps the same initiative type.',
      feedbackFormTitle: 'Feedback Form',
      feedbackForm:
        'The setup is copied as a new, unsent survey with a new link. Responses and results stay with the original.',
      neverCopiedTitle: 'Never copied',
      neverCopied: 'Completion progress, sent status.',
    },
    failed:
      'The initiative could not be duplicated. Nothing was saved. Please try again.',
    targetNotice: {
      title: 'In {target}:',
      loading: 'Checking what will change there…',
      owner: 'If the owner has no access there, you become the owner.',
      ownerChanges:
        'The owner has no access there, so you will become the owner.',
      stakeholders: 'These stakeholders will be added to that project:',
      stakeholdersGeneric:
        'Stakeholders missing there are added to that project. If the owner has no access there, you become the owner.',
    },
    newCopy: 'New copy',
    successTitle: 'Initiative duplicated.',
    successBody: '"{title}" was added to this list.',
    successBodyOtherProject: '"{title}" was added to {target}.',
    open: 'Open',
    openInProject: 'Open in {target}',
  },
};
